<template>
  <q-page>
    <div class="row">
      <div class="col-12">
        <q-card style="height: calc(100vh - 80px)">
          <q-card-section>
            <div class="row items-center">
              <div style="display: inline-block" class="text-h6">
                Competitions
              </div>
              <q-space></q-space>
              <q-btn
                class="q-ml-md"
                color="secondaryButton"
                text-color="accent"
                no-caps
                unelevated
                icon="mdi-filter"
              >
                <q-badge floating>{{ filtersActive }}</q-badge>
                <q-menu>
                  <div class="row q-pa-md">
                    <div class="col-12">
                      <div class="text-h6 q-mb-none">Filters</div>
                    </div>
                    <div class="col-12 q-mb-sm">
                      <q-input label="Search" v-model="filter.search"></q-input>
                    </div>
                    <div class="column">
                      <q-checkbox
                        v-model="filter.entriesOpen"
                        size="sm"
                        label="Entries Open"
                      />
                      <q-checkbox
                        v-model="filter.entriesClosed"
                        size="sm"
                        label="Entries Closed"
                      />
                    </div>
                    <q-separator vertical inset class="q-mx-lg" />
                    <div class="column">
                      <q-checkbox
                        v-model="filter.active"
                        size="sm"
                        label="Active"
                      />
                      <q-checkbox
                        v-model="filter.finished"
                        size="sm"
                        label="Finished"
                      />
                    </div>
                  </div>
                </q-menu>
              </q-btn>
            </div>
          </q-card-section>
          <q-separator />
          <q-card-section class="q-pa-none">
            <div>
              <div class="row q-pa-xs items-center">
                <q-select
                  filled
                  class="full-width"
                  label="Season"
                  :options="availableSeasons"
                  v-model="seasonFilter"
                >
                </q-select>
              </div>
              <div class="row">
                <q-scroll-area
                  class="col-12"
                  style="height: calc(100vh - 217px) !important"
                >
                  <q-list bordered separator style="width: 100%">
                    <q-item
                      clickable
                      v-ripple
                      v-for="(competition, index) in filteredCompetitions"
                      :key="`competition_${index}`"
                      @click="handleDoubleClick(competition)"
                    >
                      <q-item-section avatar>
                        <q-card
                          style="width: 80px"
                          flat
                          class="bg-blue-grey-4 q-py-xs q-px-md"
                        >
                          <q-card-section
                            class="q-pa-none text-bold text-center"
                          >
                            {{ $moment(competition.start_date).format("MMM") }}
                          </q-card-section>
                          <q-card-section
                            class="q-pa-none text-bold text-center"
                          >
                            {{ $moment(competition.start_date).format("D") }}
                            <!-- {{ competition.end_date }} {{ co.start_date }} -->
                            {{
                              $moment(competition.end_date).format("D") !=
                                $moment(competition.start_date).format("D") &&
                              competition.end_date
                                ? `- ${$moment(competition.end_date).format(
                                    "D"
                                  )}`
                                : ""
                            }}
                          </q-card-section>
                        </q-card>
                      </q-item-section>
                      <q-item-section>
                        {{ competition.competition_name }}
                      </q-item-section>
                      <q-item-section side>
                        <q-chip
                          square
                          :color="competitionStatus(competition).color"
                          class="text-white"
                        >
                          {{ competitionStatus(competition).name }}
                        </q-chip>
                      </q-item-section>
                    </q-item>
                  </q-list>
                </q-scroll-area>

                <!-- <datatable
                    :filter="filter.search"
                    :flat="true"
                    :data="competitions"
                    :columns="columns"
                    @rowDoubleClick="handleDoubleClick"
                  >
                  </datatable> -->
              </div>
            </div>
          </q-card-section>
        </q-card>
      </div>
    </div>
  </q-page>
</template>

<script>
import { mapGetters } from "vuex";
import datatable from "@/components/datatable/datatable.vue";

import moment from "moment";

// import { Notify } from "quasar";

export default {
  components: { datatable },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
      currentUserData: "auth/currentUserData",
      competitions: "liveResults/competitions",
      competitionsLoading: "liveResults/competitionsLoading"
    }),
    filtersActive: function() {
      let count = 0;
      if (this.filter.search) {
        count += 1;
      }

      if (this.filter.finished) {
        count += 1;
      }

      if (this.filter.active) {
        count += 1;
      }

      if (this.filter.entriesOpen) {
        count += 1;
      }

      if (this.filter.entriesClosed) {
        count += 1;
      }
      return count;
    },
    // Returns list of Seasons from 2022-23 based on July 1st season start
    availableSeasons: function() {
      const currentDate = new Date();
      const currentYear = currentDate.getFullYear();
      const currentMonth = currentDate.getMonth() + 1; // January is 0, so we add 1 to get the correct month.

      let startYear = 2022;

      let numYearsAhead = currentYear - 2022;

      if (currentMonth >= 7) {
        numYearsAhead = numYearsAhead + 1;
      }

      const seasons = [];

      for (let i = 0; i < numYearsAhead; i++) {
        seasons.push(`${startYear}-${(startYear + 1).toString()}`);
        startYear++;
      }
      return seasons;
    },
    filteredCompetitions: function() {
      return this.competitions.filter(c => {
        let currentDate = moment();
        let start_date = moment(c.start_date);
        let entriesCloseDate = moment(c.entriesCloseDate);
        let end_date = moment(c.end_date);

        if (this.seasonFilter) {
          let seasonStart = moment(
            `${this.seasonFilter.split("-")[0]}-07-01`
          ).startOf("day");
          let seasonEnd = moment(
            `${this.seasonFilter.split("-")[1]}-06-30`
          ).endOf("day");

          if (end_date < seasonStart || end_date > seasonEnd) {
            return false;
          }
        }

        if (this.filter.search) {
          let val = c.competition_name.toLowerCase();
          let matchFound =
            val.toLowerCase().indexOf(this.filter.search.toLowerCase()) > -1;
          if (matchFound != true) {
            return false;
          }
        }
        if (
          !this.filter.finished &&
          start_date < currentDate &&
          end_date < currentDate
        ) {
          return false;
        }
        if (
          !this.filter.active &&
          start_date < currentDate &&
          end_date > currentDate
        ) {
          return false;
        }
        if (
          !this.filter.entriesOpen &&
          start_date > currentDate &&
          entriesCloseDate > currentDate
        ) {
          return false;
        }
        if (
          !this.filter.entriesClosed &&
          start_date > currentDate &&
          entriesCloseDate <= currentDate
        ) {
          return false;
        }

        return true;
      });
    }
  },
  data: () => ({
    filter: {
      search: "",
      finished: true,
      active: true,
      entriesOpen: true,
      entriesClosed: true
    },
    seasonFilter: `${
      new Date().getMonth() >= 6 ? moment().year() : moment().year() - 1
    }-${new Date().getMonth() >= 6 ? moment().year() + 1 : moment().year()}`,
    columns: [
      {
        name: "competition_name",
        label: "Competition",
        align: "left",
        field: "competition_name",
        style:
          "min-width: 250px;max-width: 250px;width: 250px;white-space: normal !important;",
        sortable: true
      },
      {
        name: "eventName",
        label: "Event",
        align: "left",
        field: "event_name",
        style:
          "min-width: 150px;max-width: 150px;width: 150px;white-space: normal !important;",
        sortable: true
      },
      {
        name: "entries",
        label: "Entries",
        align: "left",
        field: "entries",
        style:
          "min-width: 100px;max-width: 100px;width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        format: (val, row) =>
          row.individualEntries > 0
            ? `${row.individualEntries} athletes`
            : row.teamEntries > 0
            ? `${row.teamEntries} teams`
            : "",
        sortable: true
      },
      {
        name: "eventProgression",
        label: "Event Progression",
        align: "left",
        style:
          "min-width: 50px;max-width: 50px;width: 50px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        sortable: true
      }
    ]
  }),
  watch: {},
  mounted() {
    this.$store.dispatch("liveResults/loadAllCompetitions");
  },
  methods: {
    handleDoubleClick(row) {
      this.$router.push(`/competition/${row.id}/wavesResults`);
    },
    competitionStatus(data) {
      let competition = JSON.parse(JSON.stringify(data));
      let currentDate = moment();
      let start_date = moment(competition.start_date);
      let entriesCloseDate = moment(competition.entriesCloseDate);
      let end_date = moment(competition.end_date);

      if (start_date > currentDate && entriesCloseDate > currentDate)
        return {
          name: "Entries Open",
          color: "positive"
        };

      if (start_date > currentDate && entriesCloseDate <= currentDate)
        return {
          name: "Entries Closed",
          color: "primary"
        };

      if (start_date <= currentDate && end_date >= currentDate)
        return {
          name: "Active",
          color: "orange"
        };

      return {
        name: "Finished",
        color: "blue-grey-5"
      };
    }
  }
};
</script>

<style lang="scss">
.container {
  width: 90%;
  min-width: 18em;
  margin: 20px auto;

  h1,
  h2 {
    text-align: center;
  }

  h1 {
    font-size: 2rem;
    font-weight: 700;
    margin-bottom: 0.5em;
  }

  h2 {
    font-size: 1.4rem;
    font-weight: 600;
    margin-bottom: 2em;
  }

  //
  // TOURNAMENT BRACKET
  // ---------------------------
  .tournament-bracket {
    display: flex;
    flex-direction: column;

    @media (min-width: $breakpoint-sm) {
      flex-direction: row;
    }
  }

  .tournament-bracket__round {
    display: block;
    margin-left: -3px;
    flex: 1;
  }

  .tournament-bracket__round-title {
    color: #9e9e9e;
    font-size: 0.95rem;
    font-weight: 400;
    text-align: center;
    margin-bottom: 0.5em;
  }

  .tournament-bracket__list {
    display: flex;
    flex-direction: column;
    flex-flow: row wrap;
    justify-content: center;
    border-bottom: 1px dashed #e5e5e5;
    padding-bottom: 2em;
    margin-bottom: 2em;
    padding-inline-start: 0px;
    transition: padding 0.2s ease-in-out, margin 0.2s ease-in-out;

    @media (max-width: $breakpoint-xs) {
      padding-bottom: 1em;
      margin-bottom: 1em;
    }

    @media (min-width: $breakpoint-sm) {
      margin-bottom: 0;
      padding-bottom: 0;
      border-right: 1px dashed #e5e5e5;
      border-bottom: 0;
    }

    .tournament-bracket__round:last-child & {
      border: 0;
    }
  }

  .tournament-bracket__item {
    display: flex;
    flex: 0 1 auto;
    justify-content: center;
    flex-direction: column;
    align-items: flex-start;
    position: relative;
    padding: 2% 0;
    width: 48%;
    transition: padding 0.2s linear;

    &:nth-child(odd) {
      margin-right: 2%;
    }

    &:nth-child(even) {
      margin-left: 2%;
    }

    &::after {
      transition: width 0.2s linear;
    }

    @media (max-width: $breakpoint-xs) {
      width: 100%;

      &:nth-child(odd),
      &:nth-child(even) {
        margin-left: 0;
        margin-right: 0;
      }
    }

    @media (min-width: $breakpoint-sm) {
      padding: 0.5em 1em;
      // flex-grow: 2;
      width: 100%;

      &:nth-child(odd),
      &:nth-child(even) {
        margin: 0;
      }

      &::after {
        position: absolute;
        right: 0;
        content: "";
        display: block;
        width: 1em;
        height: 45%;
      }

      &:nth-child(odd)::after {
        & {
          border-top-right-radius: 0.6em;
        }
      }

      &:nth-child(even)::after {
        & {
          border-bottom-right-radius: 0.6em;
        }
      }
      .tournament-bracket__round:first-child & {
        padding-left: 0;
      }
      .tournament-bracket__round:last-child & {
        padding-right: 0;

        &::after {
          display: none;
        }
      }
    }

    @media (min-width: $breakpoint-lg) {
      padding: 0.5em 1.5em;

      &::after {
        width: 1.5em;
      }
    }
  }

  .tournament-bracket__match {
    display: flex;
    width: 100%;
    background-color: #ffffff;
    padding: 1em;
    border: 1px solid transparent;
    border-radius: 0.1em;
    box-shadow: 0 2px 0 0 #e5e5e5;
    outline: none;
    cursor: pointer;
    transition: padding 0.2s ease-in-out, border 0.2s linear;

    &:focus {
      border-color: #2196f3;
    }

    &::before,
    &::after {
      transition: all 0.2s linear;
    }

    @media (max-width: $breakpoint-xs) {
      padding: 0.75em 0.5em;
    }

    @media (min-width: $breakpoint-sm) {
      &::before,
      &::after {
        position: absolute;
        left: 0;
        z-index: 1;
        content: "";
        display: block;
        width: 1em;
        height: 10%;
      }

      &::before {
      }

      &::after {
      }
    }

    @media (min-width: $breakpoint-lg) {
      &::before,
      &::after {
        width: 1.5em;
      }

      &::before {
        transform: translate(0, 1px);
      }

      &::after {
        transform: translate(0, -1px);
      }
    }
  }

  .tournament-bracket__round:last-child .tournament-bracket__match {
    &::before,
    &::after {
      border-left: 0;
    }

    &::before {
      border-bottom-left-radius: 0;
    }

    &::after {
      display: none;
    }
  }

  .tournament-bracket__round:first-child .tournament-bracket__match {
    &::before,
    &::after {
      display: none;
    }
  }

  .tournament-bracket__table {
    width: 100%;

    .clubCap {
      width: 40px;
    }
  }

  .tournament-bracket__caption {
    font-size: 0.8rem;
    color: #bdbdbd;
    font-weight: 300;
    padding-bottom: 0.75em;
  }

  .singlePassthrough::after {
    border-radius: 0 !important;
    border-right: 0;
    // border-top: 0 !important;
  }

  .notBracket::after {
    border-radius: 0 !important;
    border-right: 0 !important;
    border-top: 0 !important;
    border-bottom: 0 !important;
  }

  .notBracket {
    .tournament-bracket__match {
      &::before {
        border-radius: 0 !important;
        border-left: 0 !important;
        border-bottom: 0 !important;
      }

      &::after {
        border-radius: 0 !important;
        border-left: 0 !important;
        border-top: 0 !important;
      }
    }
  }

  .bracketStart {
    .tournament-bracket__match {
      &::before {
        border-radius: 0 !important;
        border-left: 0 !important;
        border-bottom: 0 !important;
      }

      &::after {
        border-radius: 0 !important;
        border-left: 0 !important;
        border-top: 0 !important;
      }
    }
  }

  .finalBracket::after {
    border-radius: 0 !important;
    border: 0 !important;
  }
  .noMoreEvents {
    border-right: 0;
  }
}
</style>
